import {gsap} from "gsap";
import {Flip} from "gsap/Flip";
import { lenis } from './main.js'


gsap.registerPlugin(Flip);
let imgFlip;

export const TransitionTypo = {
    name: 'home-typo',
    custom({ trigger }) {
        return trigger && trigger.classList.contains('typo-transition');
    },
    leave(data) {



        return new Promise(resolve => {


            imgFlip = data.trigger.querySelector('img');

            let flipState = Flip.getState(imgFlip);


            gsap.set(imgFlip.parentNode,{
                height : () => {
                    return imgFlip.parentNode.clientHeight;
                },
                width : () => {
                    return imgFlip.parentNode.clientWidth;
                }
            })



            document.querySelector('.transition-overlay').append(imgFlip);



            gsap.to('.transition-slide',{
                yPercent: 0,
                y: 0,
                ease: "expo.out",
                duration: 1.5
            })



            gsap.to(data.current.container,{
                opacity:0,
                duration: 2,
                ease: "expo.out",
            })

            Flip.from(flipState, {
                duration: 2,
                ease: "expo.out",
                absolute: true,
                onComplete: () => {



                    lenis.scrollTo(0, { immediate: true })
                    lenis.stop()



                    data.current.container.classList.add('d-none');
                    resolve()




                }
            });




        })







    },
    enter(data) {


        return new Promise(resolve => {

            gsap.set('.bht__image img',{
                opacity:0
            })
            gsap.set('.bht__image--2 img',{
                opacity:0,
                x: '2.5rem',
                y: '2.5rem'
            })

            gsap.set('.bht__intro',{
                opacity:0
            })

            gsap.set('.bht__t',{
                opacity:0
            })

            gsap.set('.block-image',{
                opacity:0
            })




            gsap.to('.transition-slide',{
                yPercent: -100,
                ease: "expo.out",
                duration: 1.5,
                onComplete: () => {


                    document.querySelector('.header').classList.add('inverted');
                    document.querySelector('.header').classList.remove('hide');
                    document.querySelector('.header').classList.remove('sticky');

                    gsap.set('.transition-slide',{
                        clearProps: 'all',
                    })


                    const newFlipState = Flip.getState(imgFlip);

                    const targetDiv = data.next.container.querySelector('.bht__image-cover');
                    targetDiv.innerHTML = '';

                    targetDiv.appendChild(imgFlip);




                    Flip.from(newFlipState, {
                        duration: 2,
                        ease: "expo.out",
                        onComplete : () => {
                            document.body.classList.remove('wait');
                            resolve();
                        }
                    });

                    gsap.to('.bht__intro',{
                        opacity:1,
                        duration: 2,
                        delay: .5,
                        ease: "expo.out",
                    })

                    gsap.to('.bht__t',{
                        opacity:1,
                        duration: 2,
                        delay: .5,
                        ease: "expo.out",
                    })

                    gsap.to('.block-image',{
                        opacity:1,
                        duration: 2,
                        delay: .5,
                        ease: "expo.out",
                    })

                    gsap.to('.bht__image--2 img',{
                        x: 0,
                        y: 0,
                        opacity:1,
                        duration: 2,
                        delay: .5,
                        ease: "expo.out",
                    })

                    lenis.start()
                    console.log('qua')

                }
            })






        })

    },
    afterEnter(data) {

    }
}
